import React from 'react'
import './AnimateContainer.scss';
import { AnimatePresence, motion } from 'framer-motion';

const AnimateContainer = ({children, direction, disableAnimation, animationKey}) => {
  return (

    disableAnimation ? <>
        {children}
    </> : <AnimatePresence mode="wait">
        <motion.div
            key={animationKey}
            initial={{ opacity: 0, x: direction === "back" ? 50 : -50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: direction === "back" ? -50 : 50 }}
            transition={{ duration: 0.5 }}
        >
            {children}
        </motion.div>
    </AnimatePresence>
  )
}

export default AnimateContainer